import { createAction } from 'redux-actions'
import { createRequestActions as request } from 'store/actionCreators'

export const setFilterBySearch = createAction('REVIEWS/SET_FILTER_BY_SEARCH', value => value)

// works together with ORGANIZATIONS/USERS_FILTER_BY_TEAM. We should separate organizations if we want to separate logic
export const setFilterByTeam = createAction('REVIEWS/SET_FILTER_BY_TEAM', value => value)

export const setFilterByStatus = createAction('REVIEWS/SET_FILTER_BY_STATUS', value => value)

export const setFilterBySort = createAction('REVIEWS/SET_FILTER_BY_SORT', (by, desc) => ({
  by,
  desc,
}))

export const getReviewsMessaging = request('REVIEWS/GET_REVIEWS_MESSAGING', organizationId => {
  return {
    request: {
      url: `/organizations/${organizationId}/reviews/messaging`,
    },
  }
})

export const postOrPutReviewsMessaging = request(
  'REVIEWS/POST_OR_PUT_REVIEWS_MESSAGING',
  ({ organizationId, data, method = 'POST', currentTab }) => {
    // data = {
    //    organizationId,
    //    data: {
    //      [`${currentTab}Subject`]: subject: string,
    //      [`${currentTab}Image`]: image: string,
    //      [`${currentTab}Text`]: text: string
    //    },
    //    method: !initialValues.get('subject') ? 'POST' : 'PUT',
    //    currentTab
    // }
    return {
      request: {
        url: `/organizations/${organizationId}/reviews/messaging`,
        method,
        data,
        helper: { currentTab, organizationId, data },
      },
      success: `Updating was successful`,
      fail: `Updating failed`,
    }
  }
)

export const getReviewsUsers = request('REVIEWS/GET_REVIEWS_USERS', organizationId => {
  return {
    request: {
      url: `/organizations/${organizationId}/reviews/users`,
    },
  }
})

export const postReviewsUserReviewers = request(
  'REVIEWS/POST_REVIEWS_USERS_REVIEWERS',
  ({ organizationId, userId, data, helper }) => {
    // data = {
    //  reviewType: 't1' || 't2',
    //  reviewersType: 'superior', 'peer', 'employee',
    //  reviewers: [{
    //    firstName: string,
    //    lastName: string,
    //    email: string,
    //    isComplete: boolean,
    //  }]
    // }
    return {
      request: {
        url: `/organizations/${organizationId}/reviews/${userId}/reviewers`,
        method: 'POST',
        data,
        helper,
      },
      success: `Updating user's reviewers was successful`,
      fail: `Updating user's reviewers failed`,
    }
  }
)

export const postReviewsUserReminder = request(
  'REVIEWS/POST_REVIEWS_USER_REMINDER',
  ({ organizationId, userId, data }) => {
    // data = {
    //   reviewType: string; "t1" || "t2"
    //   self: boolean;
    // }
    return {
      request: {
        url: `/organizations/${organizationId}/reviews/users/${userId}/reminder`,
        method: 'POST',
        data,
      },
      success: `Reminder was send successfully`,
      fail: `Sending reminder failed`,
    }
  }
)

export const processReportsQuery = createAction('REVIEWS/PROCESS_REPORTS_QUERY')

export const fetchReviewsReport = request('REVIEWS/GET_REVIEWS_REPORT', ({ organizationId, userId, reviewType }) => ({
  request: {
    url: `organizations/${organizationId}/reviews/users/${userId}/report/${reviewType}`,
  },
  fail: "Can't get report data",
}))

export const postReviewsUserReminderBulk = request(
  'REVIEWS/POST_REVIEWS_USER_REMINDER_BULK',
  ({ organizationId, data }) => {
    // data = [
    //  {
    //    email: string,
    //    firstName: string,
    //    lastName: string,
    //    reviewType: string; "t1" || "t2",
    //    isSelfInvitationSent: bool
    //  }
    // ]
    return {
      request: {
        url: `organizations/${organizationId}/reviews/users/reminder`,
        method: 'POST',
        data,
      },
      success: `Reminders was send successfully`,
      fail: `Sending reminders failed`,
    }
  }
)

export const postReviewersReminderBulk = request('REVIEWS/POST_REVIEWERS_REMINDER_BULK', ({ organizationId, data }) => {
  // data = [
  //  {
  //     participantEmail: string,
  //     participantFirstName: string,
  //     participantLastName: string,
  //     reviewerEmail: string,
  //     reviewerFirstName: string,
  //     reviewerLastName: string,
  //     reviewType: string; "t1" || "t2",
  //     reviewerType: 'superior', 'peer', 'employee',
  //  }
  // ]
  return {
    request: {
      url: `organizations/${organizationId}/reviews/reviewers/reminder`,
      method: 'POST',
      data,
    },
    success: `Reminders was send successfully`,
    fail: `Sending reminders failed`,
  }
})

export const selectPage = createAction('REVIEWS/SELECT_PAGE', page => page)

export const postReviewsReportBulk = request(
  'REVIEWS/POST_REVIEWS_REPORT_BULK',
  ({ organizationId, data, reviewType }) => {
    // data = {
    //  users: [test1@prohabits.com, test2@prohabits.com]
    // }
    const helper = { data, reviewType }
    return {
      request: {
        url: `organizations/${organizationId}/reviews/users/report/${reviewType}/bulk`,
        method: 'POST',
        data,
        helper,
      },
      success: 'Reports was created successfully',
      fail: 'Reports creating failed',
    }
  }
)
